(function() {
  function init() {
    var sections = document.querySelectorAll('.bd-real-spaces');
    sections.forEach(function(section) {
      if (section.dataset.bdRealSpacesInit === 'true') return;
      section.dataset.bdRealSpacesInit = 'true';

      var tabs = section.querySelectorAll('.bd-real-spaces__tab');
      var panels = section.querySelectorAll('.bd-real-spaces__panel');
      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          var index = this.getAttribute('data-collection-index');
          tabs.forEach(function(t) {
            t.classList.remove('bd-real-spaces__tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function(p) {
            p.classList.remove('bd-real-spaces__panel--active');
            p.hidden = true;
          });
          this.classList.add('bd-real-spaces__tab--active');
          this.setAttribute('aria-selected', 'true');
          var panel = section.querySelector('.bd-real-spaces__panel[data-collection-index="' + index + '"]');
          if (panel) {
            panel.classList.add('bd-real-spaces__panel--active');
            panel.hidden = false;
          }
        });
      });

      section.addEventListener('click', function(e) {
        var btn = e.target.closest('.bd-real-spaces__show-more-btn');
        if (!btn) return;
        var wrap = btn.closest('.bd-real-spaces__show-more-wrap');
        var panel = btn.closest('.bd-real-spaces__panel');
        var grid = panel ? panel.querySelector('.bd-real-spaces__grid') : null;
        if (grid && wrap) {
          grid.classList.add('bd-real-spaces__grid--expanded');
          wrap.classList.add('bd-real-spaces__show-more-wrap--hidden');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
